import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirTransferenciasMunicipiosEstados } from './types';

export const INITIAL_STATE: emitirTransferenciasMunicipiosEstados = {
	status: 0,
	data: null,
	form: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirTransferenciasMunicipiosEstados {
	return produce(state, draft => {
		switch (action.type) {
			case Types.SALVAR_DADOS_FORM: {
				draft.form = action.payload;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_ESTADOS_REQUEST: {
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_ESTADOS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_ESTADOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_ESTADOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
